<template>

    <div class="must-have-exactly-one-root-element">

        <menu-satnik
            :kravicka="kravicka"
            :activeCategory="filterSatnikKategoriaTyp"
            @showProducts="showProducts"
        />

        <div class="container-fluid pl-0 pr-0">

            <div class="row no-gutters">

                <div class="col-lg-6 col-xl-6">

                    <section class="shopProducts --lightBg" :class="{'open': showShopProducts}">

                        <div class="shopHeader --whiteBg d-flex">

                            <h2 class="mb-0">Šatník</h2>

                            <div class="shopHeader__right">

                                <span class="takeOff d-none d-md-inline-block" @click="vyzliectKravicku">
                                    <span class="icon"></span>Vyzliecť kravičku
                                </span>

                                <button class="takeOffButton btn --secondary d-md-none" @click="vyzliectKravicku">
                                    <span class="icon"></span>
                                </button>

                                <button class="downloadButton btn --primary" @click="printScreen">
                                    <span class="icon --loader fa-spin" v-if="showLoader"></span>
                                    <span class="icon" v-else></span>
                                </button>

                                <button class="fbButton btn --facebookNormal" @click="fbShare">
                                    <span class="icon"></span>
                                </button>

                            </div>

                        </div>

                        <!-- Alert box -->
                        <div v-if="responseText != ''" :class="'alert alert-dismissible fade show --shopAlert alert-'+responseType" role="alert">
                            <p class="mb-0">
                                <span :class="'icon --'+responseType"></span>{{ responseText }}
                            </p>

                            <button @click="responseText = ''" type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="o-dressingRoom__products">

                            <div class="dressingRoom__header d-flex">

                                <h3>{{ filterSatnikKategoriaNazov }}</h3>

                                <div class="dressingRoom__filter">

                                    <span
                                        class="--likeLink d-none d-md-inline-block pl-0"
                                        :class="{'--active': filterSatnikProduktStav === 'all' }"
                                        @click="filterSatnikProduktStav='all'"
                                    >
                                        Všetky
                                    </span>

                                    <span
                                        class="--likeLink d-none d-md-inline-block"
                                        :class="{'--active': filterSatnikProduktStav === 'kupene' }"
                                        @click="filterSatnikProduktStav='kupene'"
                                    >
                                        Zakúpené
                                    </span>

                                    <span
                                        class="--likeLink d-none d-md-inline-block pr-0"
                                        :class="{'--active': filterSatnikProduktStav === 'nekupene' }"
                                        @click="filterSatnikProduktStav='nekupene'"
                                    >
                                        Nezakúpené
                                    </span>

                                    <select class="custom-select d-md-none" id="inputGroupSelect01" v-model="filterSatnikProduktStav">
                                        <option value="all">Všetky</option>
                                        <option value="kupene">Zakúpené</option>
                                        <option value="nekupene">Nezakúpené</option>
                                    </select>

                                </div>

                            </div>

                            <div class="o-productGrid">

                                <div v-if="satnik.length > 0" class="m-productGrid__list --small">

                                    <template
                                        v-for="(produkt, index) in satnik.filter(filterSatnikProdukty)"
                                    >

                                        <div
                                            class="a-productGrid__item mb-2 --small"
                                            :class="{'--dressed': produkt.active === 1, '--bought': produkt.active === 0 && produkt.disabled === 1 }"
                                            :style="'z-index:' + [100 - index]"
                                        >

                                            <div class="productGridItem_content">
                                                <img :src="'assets/img/satnik-icons/' + produkt.satnik_produkt_ikona" alt="" class="img-fluid">
                                                <div class="productGridItem__title">{{ produkt.satnik_produkt_meno }}</div>
                                                <div v-if="produkt.disabled === 1" class="productGridItem__alreadyBought">Zakúpené</div>
                                                <div v-else class="productGridItem__price"><span class="icon"></span>{{ produkt.satnik_produkt_cena }}</div>
                                            </div>

                                            <span v-if="produkt.satnik_produkt_novinka === 1" class="productGridItem__new__tag">Nové</span>

                                            <span v-if="produkt.active === 1" class="productGridItem__applied"><span class="icon"></span></span>

                                            <div v-if="produkt.disabled === 0" class="productGridItem__button">
                                                <button class="btn" @click="buySatnikProduct(satnik.indexOf(produkt), produkt)">
                                                    <span class="icon"></span>Kúpiť
                                                </button>
                                            </div>

                                            <div v-if="produkt.active === 0 && produkt.disabled === 1" class="productGridItem__button">
                                                <button class="btn" @click="useSatnikProduct(satnik.indexOf(produkt), produkt)">
                                                    <span class="icon"></span>Obliecť
                                                </button>
                                            </div>

                                            <div v-if="produkt.active === 1" class="productGridItem__button">
                                                <button class="btn" @click="hideSatnikProduct(satnik.indexOf(produkt), produkt)">
                                                    <span class="icon"></span>Vyzliecť
                                                </button>
                                            </div>

                                        </div>

                                    </template>

                                </div>

                            </div>

                        </div>

                        <button id="closeShopMenu" class="btn --primary d-md-none" @click="showShopProducts=false"><span class="icon"></span></button>

                    </section>

                </div>

                <div class="col-lg-6 col-xl-6">

                    <section class="shopCowPreview --lightBg" ref="contentWrapper">

                        <div class="shopCowPreview__cow">

                            <div class="shopCowPreview__imageWrap">

                                <img src="assets/img/satnik/AK_Standing.png" alt="" height="800">

                                <div class="shopCowPreview__dressWrap">

                                    <template
                                        v-for="produkt in satnik"
                                    >

                                        <img
                                            v-if='produkt.satnik_produkt_povoleny === "1"'
                                            :src="'assets/img/satnik/' + produkt.satnik_produkt_img"
                                            :class="{ '--hidden': !produkt.active }"
                                            :style="{ 'z-index' : getProduktZIndex(produkt) }"
                                            alt=""
                                            height="800"
                                        >

                                    </template>

                                </div>

                            </div>

                        </div>

                    </section>

                </div>

                <header-satnik
                        @updateProfil="emitUpdateProfil"
                        :profil="profil"
                />

            </div>

        </div>

    </div>

</template>



<script>
    import EventService      from '@/services/EventService.js'
    import MenuSatnik        from '../partials/MenuSatnik.vue'
    import ObchodProductGrid from '../partials/ObchodProductGrid.vue'
    import DomToImage        from 'dom-to-image'
    import { saveAs }        from 'file-saver'
    import HeaderSatnik      from "../partials/HeaderSatnik.vue"

    export default {
        components: {
            HeaderSatnik,
            MenuSatnik,
            ObchodProductGrid
        },
        props: [
            'profil',
            'kravicka',
            'satnik',
            'kategoria'
        ],
        mounted() {
            this.getKravickaData()
        },
        data() {
            return {
                ownedItemsArr: [],
                activeItemsArr: [],

                filterSatnikProduktStav: 'all',
                filterSatnikKategoriaTyp: 'bezpecnost',
                filterSatnikKategoriaNazov: 'Bezpečnosť',
                showShopProducts: false,
                showLoader: false,

                responseType: '',
                responseText: ''
            }
        },
        computed: {
            // achievements ids (9, 17, 23)
            komboOblecenia1() {
                return [24,76,62] // plavky, plutvy, masku
            },
            komboOblecenia2() {
                return [28,66,48,52,57,42] // spoločenské šaty, škriatkovské topánky, kabelka, koruna, náhrdelník, zlatý prsteň
            },
            komboOblecenia3() {
                return [16,67,77,12,31] // pončo, smart hodinky, žabky, 3D okuliare, mobil
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },

            printScreen() {
                this.showLoader = true
                let _this = this
                DomToImage.toBlob(this.$refs.contentWrapper)
                    .then(function (blob) {
                        _this.checkAchievementStiahniFotkuKravicky()
                        _this.showLoader = false
                        saveAs(blob, 'adoptujkravicku.png')
                    })
            },

            fbShare() {
                let _this = this
                DomToImage.toBlob(this.$refs.contentWrapper)
                    .then(function (blob) {
                        EventService.satnikFbShare(_this.profil.pouzivatel_id.id, _this.$route.params.kravicka_id, blob)
                            .then(response => {
                                _this.checkAchievementZdielajKravicku()
                                window.open(
                                    'https://adoptujkravicku.sk/hra2019/src/fbshare.php?' + _this.profil.pouzivatel_id.id + '&' + _this.$route.params.kravicka_id + '&' + Date.now(),
                                    '_blank'
                                )
                            })
                    })
            },

            // mounted
            getKravickaData() {
                if (typeof(this.kravicka.id) == 'undefined' || this.$route.params.kravicka_id != this.kravicka.id) {
                    this.$emit('update:kravicka', {})
                    EventService.getKravickaData(this.$route.params.kravicka_id)
                        .then(response => {
                            //console.log(response.data)
                            this.param_global = Number((response.data.data[0].kravicka_param_global).toFixed(0))
                            this.$emit('update:kravicka', response.data.data[0])

                            // vlastnené a aktívne produkty
                            var inv = response.data.data[0].satnik_kravicky
                            for (var i = 0; i < inv.length; i++) {
                                this.ownedItemsArr[inv[i].satnik_produkt_id] = inv[i].satnik_produkt_id
                                if (inv[i].repozitar_satnika_used == 1) {
                                    this.activeItemsArr[inv[i].satnik_produkt_id] = inv[i].satnik_produkt_id
                                }
                            }

                            this.getSatnikData()
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })

                } else {
                    //console.log(this.kravicka)
                    this.param_global = Number((this.kravicka.kravicka_param_global).toFixed(0))

                    // vlastnené a aktívne produkty
                    var inv = this.kravicka.satnik_kravicky
                    for (var i = 0; i < inv.length; i++) {
                        this.ownedItemsArr[inv[i].satnik_produkt_id] = inv[i].satnik_produkt_id
                        if (inv[i].repozitar_satnika_used == 1) {
                            this.activeItemsArr[inv[i].satnik_produkt_id] = inv[i].satnik_produkt_id
                        }
                    }

                    this.getSatnikData()
                }
            },

            getSatnikData() {
                if (typeof(this.satnik[0]) == 'undefined') {
                    EventService.getSatnikData()
                        .then(response => {
                            //console.log(response.data)

                            // disable use pre aktívne a buy pre vlastnené produkty
                            var prod = response.data.data
                            for (var i = 0; i < prod.length; i++) {
                                prod[i].active = 0
                                prod[i].disabled = 0
                                if (typeof(this.activeItemsArr[prod[i].id]) != "undefined") {
                                    prod[i].active = 1
                                }
                                if (typeof(this.ownedItemsArr[prod[i].id]) != "undefined") {
                                    prod[i].disabled = 1
                                }
                            }

                            this.$emit('update:satnik', prod)
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            },


            // click
            buySatnikProduct(index, item) {
                EventService.buySatnikProduct(this.kravicka.id, item.id)
                    .then(response => {
                        //console.log(response.data)
                        this.responseType = response.data.code
                        this.responseText = response.data.data

                        if (response.data.code == 'success') {
                            // odrátaj dukáty
                            this.profil.pouzivatel_id.pouzivatel_wallet -= parseFloat(item.satnik_produkt_cena)
                            this.$emit('update:profil', this.profil)

                            // nastav zakúpený produkt
                            var newItem = {
                                satnik_produkt_id: item.id,
                                repozitar_satnika_used: 0, // po zakúpení (0 - neobliecť / 1 - obliecť)
                            }

                            this.kravicka.satnik_kravicky.push(newItem)
                            this.$emit('update:kravicka', this.kravicka)

                            // disable opakované zakúpenie produktu
                            this.satnik[index].disabled = 1
                            //this.satnik[index].active = 1 // po zakúpení obliecť
                            this.$emit('update:satnik', this.satnik)
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },

            useSatnikProduct(index, item) {
                EventService.useSatnikProduct(this.kravicka.id, item.id, item.satnik_produkt_kategoria_id.id)
                    .then(response => {
                        //console.log(response.data)
                        this.responseType = response.data.code
                        this.responseText = response.data.data

                        if (response.data.code == 'success') {
                            // získaj konfliktné kategórie
                            var konflikt = item.satnik_produkt_kategoria_id.satnik_kategoria_konflikt.split(";")
                            //console.log(konflikt)

                            // nájdi konfliktné produkty
                            /*var items = this.satnik
                            for (var i = 0; i < items.length; i++) {
                                // kontroluj iba oblečené produkty
                                if (typeof(items[i].active) != "undefined" && items[i].active == 1) {
                                    for (var j = 0; j < konflikt.length; j++) {
                                        if (items[i].satnik_produkt_kategoria_id.id == parseInt(konflikt[j])) {
                                            console.log('vyzleč ID:' + items[i].id)
                                            items[i].active = 0
                                        }
                                    }
                                }
                            }

                            // olbeč produkt
                            items[index].active = 1
                            this.$emit('update:satnik', items)*/
                            //this.$set(this.satnik, items)

                            // nájdi konfliktné produkty
                            for (var i = 0; i < this.satnik.length; i++) {
                                // kontroluj iba oblečené produkty
                                if (typeof(this.satnik[i].active) != "undefined" && this.satnik[i].active == 1) {
                                    for (var j = 0; j < konflikt.length; j++) {
                                        if (this.satnik[i].satnik_produkt_kategoria_id.id == parseInt(konflikt[j])) {
                                            console.log('vyzleč ID:' + this.satnik[i].id)
                                            this.satnik[i].active = 0
                                        }
                                    }
                                }
                            }

                            // olbeč produkt
                            this.satnik[index].active = 1
                            this.checkSatnikObliekanieAchievements()
                            this.$emit('update:satnik', this.satnik)
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },

            hideSatnikProduct(index, item) {
                EventService.hideSatnikProduct(this.kravicka.id, item.id)
                    .then(response => {
                        //console.log(response.data)
                        this.responseType = response.data.code
                        this.responseText = response.data.data

                        if (response.data.code == 'success') {
                            // vyzleč produkt
                            this.satnik[index].active = 0
                            this.$emit('update:satnik', this.satnik)
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },

            vyzliectKravicku() {
                let _this = this
                this.satnik.forEach(function (satnikProdukt, index) {
                    if ( satnikProdukt.active === 1) {
                        _this.hideSatnikProduct(index, satnikProdukt)
                    }
                })
            },

            showProducts(category, name) {
                this.filterSatnikKategoriaTyp = category
                this.filterSatnikKategoriaNazov = name
                this.showShopProducts = true
            },

            filterSatnikProdukty(satnikProdukt) {

                if ( satnikProdukt.satnik_produkt_povoleny !== "1" ) {
                    return false
                }
                if ( this.filterSatnikProduktStav === 'kupene' && satnikProdukt.disabled === 0 ) {
                    return false
                }
                if ( this.filterSatnikProduktStav === 'nekupene' && satnikProdukt.disabled === 1 ) {
                    return false
                }
                if ( this.filterSatnikKategoriaTyp !== satnikProdukt.satnik_produkt_kategoria_id.satnik_kategoria_typ ) {
                    return false
                }

                return true
            },

            getProduktZIndex(satnikProdukt) {
                if ( satnikProdukt.satnik_produkt_z_index !== null) {
                    return satnikProdukt.satnik_produkt_z_index
                }
                else if ( satnikProdukt.satnik_produkt_kategoria_id.satnik_kategoria_z_index !== null ) {
                    return satnikProdukt.satnik_produkt_kategoria_id.satnik_kategoria_z_index
                }
                else {
                    return 5
                }
            },

            checkSatnikObliekanieAchievements() {
                console.log('checkSatnikObliekanieAchievements')
                this.checkAchievementOblecKravickuPrvykrat()
                this.checkAchievementOblecKravickuKombo()
            },

            checkAchievementOblecKravickuPrvykrat() {
                this.checkSatnikGeneralAchievement(18)
            },

            checkAchievementOblecKravickuKombo() {

                if ( this.checkAchievementOblecenaKravickaKombo( this.komboOblecenia1 ) ) {
                    this.checkSatnikGeneralAchievement(9)
                }

                if ( this.checkAchievementOblecenaKravickaKombo( this.komboOblecenia2 ) ) {
                    this.checkSatnikGeneralAchievement(17)
                }

                if ( this.checkAchievementOblecenaKravickaKombo( this.komboOblecenia3) ) {
                    this.checkSatnikGeneralAchievement(23)
                }

            },

            checkAchievementOblecenaKravickaKombo(komboOblecenia) {
                for (let item of komboOblecenia) {
                    if ( this.satnik.find(produkt => produkt.id === item).active !== 1 ) {
                        return false
                    }
                }

                return true
            },

            checkAchievementZdielajKravicku() {
                this.checkSatnikGeneralAchievement(35)
            },

            checkAchievementStiahniFotkuKravicky() {
                this.checkSatnikGeneralAchievement(11)
            },

            checkSatnikGeneralAchievement(achievementId) {
                var key = EventService.checkAchievementProgress(this.profil, achievementId)
                if (key > -2) {
                    EventService.setAchievementProgress(this.profil, achievementId)
                        .then(response => {
                            //console.log(response.data)
                            //this.responseType = response.data.code
                            //this.responseText = response.data.data

                            sessionStorage.setItem("album-uspechy", "refresh")

                            if (key == -1) {
                                this.$emit('updateProfil')
                            } else {
                                this.profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_current += 1
                                this.$emit('update:profil', this.profil)
                            }

                            // achievements toast popup
                            this.$toast.success(' ', response.data.data)
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            }


        }
    }
</script>